import { unitMapping } from 'lib/style';

type Props = {
  size?: keyof typeof unitMapping;
  active?: boolean;
};
export const HeartIcon = ({ size = 2, active = false }: Props) => {
  return (
    <svg
      style={{ width: unitMapping[size], height: unitMapping[size] }}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.75 8.76282L8.73948 16.8698L0.75 8.76282V3.21615L4.75526 0.869797L8.76052 3.21615L12.7553 0.869797L16.75 3.21615V8.76282Z"
        fill="#FF0974"
        fillOpacity={active ? 1 : 0.2}
        stroke="#FF2828"
        strokeWidth="1.5"
      />
    </svg>
  );
};
